import { Component, HostListener, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { UserService } from '../user.service';
import { UserModel } from '../model/user.model';

import { UserGroupMenuModel } from '../../usergroup/model/usergroupmenu.model';
import e from 'express';
import { UserGroupService } from '../../usergroup/usergroup.service';
import { EmployeeService } from '../../../employees/employee/employee.service';
import { EmployeeModel } from '../../../employees/employee/model/employee.model';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import * as CryptoJS from 'crypto-js';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-user-edit',
  standalone: false,
  templateUrl: './user-edit.component.html',
  styleUrl: './user-edit.component.scss'
})
export class UserEditComponent {
  title: string = "New User ";
  editForm: FormGroup;
  userGroupInfo: UserModel = {};
  userGroupMenuInfo: UserGroupMenuModel = {};
  isFormDirty: boolean = false;
  userGroupList: UserModel[] = [];
  employeeList: EmployeeModel[] = [];
  shopUserMapping: any[] = [];
  sortedShopUserMapping: any[] = [];
  shopUserMappingLoadedFromSetUserGroupInfo = false;
  areaList: string[] = [];
  selectedAreas: string[] = [];

  shopSearch: string = '';
  permission: any;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
    private userGroupService: UserGroupService,
    private employeeService: EmployeeService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private permissionService: PermissionService,
    private zone: NgZone
  ) {

    let userGroupId = this.route.snapshot.paramMap.get('id');

    this.editForm = this.builder.group({
      code: this.builder.control(this.userGroupInfo.code, [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(this.userGroupInfo.name, [Validators.required, Validators.maxLength(50)]),
      card_no: this.builder.control(this.userGroupInfo.card_no),
      email: this.builder.control(this.userGroupInfo.email, [Validators.email, Validators.maxLength(100)]),
      valid_from: this.builder.control(this.userGroupInfo.valid_from),
      valid_to: this.builder.control(this.userGroupInfo.valid_to),
      user_group_id: this.builder.control(this.userGroupInfo.user_group_id, [Validators.required]),
      employee_id: this.builder.control(this.userGroupInfo.employee_id),
      is_active: this.builder.control(
        this.toBoolean(this.userGroupInfo.is_active), // use helper
      ),

      user_type: this.builder.group({
        hq: [false],
        shop: [false],
        areaManager: [false],
      }),
    }, { validators: this.dateRangeValidator });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (userGroupId !== null && parseInt(userGroupId) !== 0) {
      this.setuserGroupInfo(userGroupId);
    }
    this.setupUserTypeLogic();
    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission("user"), userGroupId);

  }
  ngOnInit(): void {
    this.loadUserGroupData();
    this.loadEmployeeData();
    this.editForm.get('user_group_id')?.valueChanges.subscribe(userGroupId => {
      // Only call getShopUserMapping if setuserGroupInfo did NOT already call it
      if (!this.shopUserMappingLoadedFromSetUserGroupInfo) {
        if (userGroupId) {
          this.userService.getShopUserMapping(Number(userGroupId)).subscribe(res => {
            this.zone.run(() => {
              if (res.status === 'SUCCESS') {
                this.shopUserMapping = [...res.data];
                // Extract unique area/city list
                this.areaList = Array.from(new Set(this.shopUserMapping.map(shop => shop.city))).filter(Boolean);
                // By default, select all areas
                this.selectedAreas = [...this.areaList];
                this.sortedShopUserMapping = this.getFilteredAndSortedShopUserMapping();
              } else {
                this.shopUserMapping = [];
                this.areaList = [];
                this.selectedAreas = [];
                this.sortedShopUserMapping = [];
              }
              console.log('shopUserMapping after load:', this.shopUserMapping);
              this.cdr.detectChanges();
            });
          });
        } else {
          this.zone.run(() => {
            this.shopUserMapping = [];
            this.sortedShopUserMapping = [];
            this.cdr.detectChanges();
          });
        }
      }
      // Reset the flag for subsequent changes
      this.shopUserMappingLoadedFromSetUserGroupInfo = false;
    });
  }

  setupUserTypeLogic() {
    const userTypeGroup = this.editForm.get('user_type') as FormGroup;

    userTypeGroup.get('areaManager')?.valueChanges.subscribe(isChecked => {
      if (isChecked) {
        userTypeGroup.patchValue({ hq: false, shop: false }, { emitEvent: false });
      }
    });

    userTypeGroup.get('hq')?.valueChanges.subscribe(isChecked => {
      if (isChecked) {
        userTypeGroup.patchValue({ areaManager: false }, { emitEvent: false });
      }
    });

    userTypeGroup.get('shop')?.valueChanges.subscribe(isChecked => {
      if (isChecked) {
        userTypeGroup.patchValue({ areaManager: false }, { emitEvent: false });
      }
    });
  }

  get showMenuCheckboxes() {
    return this.editForm.get('user_type.shop')?.value;
  }

  getUserTypeValue(): number {
    const ut = this.editForm.get('user_type')?.value;
    if (ut.areaManager) return 3;
    if (ut.hq && ut.shop) return 2;
    if (ut.hq) return 0;
    if (ut.shop) return 1;
    return -1;
  }

  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/user/user']);

  }

  /**
   * If tas is is null set an empty area info
   * if area id is not null call api to rtrive the info
   * @param userGroupId 
   */
  setuserGroupInfo(userGroupId: any): void {

    let response = this.userService.getById(userGroupId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.userGroupInfo = response.data.users;
          // const menu = response.data.user_group.menu;

          // SET USER TYPE

          const userTypeGroup = this.editForm.get('user_type') as FormGroup;
          if (this.userGroupInfo.employee_id) {
            this.userGroupInfo.employee_id = Number(this.userGroupInfo.employee_id);
          }
          if (this.userGroupInfo.user_group_id) {
            this.userGroupInfo.user_group_id = Number(this.userGroupInfo.user_group_id);
          }
          // Set the flag BEFORE patching the form to prevent duplicate API call
          this.shopUserMappingLoadedFromSetUserGroupInfo = true;
          // Ensure is_active is boolean for the form, but keep as number in the model
          const patchObj = { ...this.userGroupInfo, is_active: this.toBoolean(this.userGroupInfo.is_active) };
          this.editForm.patchValue(patchObj);
          if (this.userGroupInfo.user_type == 3) {
            userTypeGroup.patchValue({ hq: false, shop: false, areaManager: true });
          } else if (this.userGroupInfo.user_type == 2) {
            userTypeGroup.patchValue({ hq: true, shop: true, areaManager: false });
          } else if (this.userGroupInfo.user_type == 1) {
            userTypeGroup.patchValue({ hq: false, shop: true, areaManager: false });
          } else {
            userTypeGroup.patchValue({ hq: true, shop: false, areaManager: false });
          }

          // const menuGroup = this.editForm.get('menu') as FormGroup;
          // menuGroup.patchValue({
          //   is_dashboard_page_visible: menu?.is_dashboard_page_visible,
          //   is_people_page_visible: menu?.is_people_page_visible,
          //   is_utilities_page_visible: menu?.is_utilities_page_visible,
          //   is_reports_page_visible: menu?.is_reports_page_visible,
          //   is_settings_page_visible: menu?.is_settings_page_visible,
          //   is_manager_page_visible: menu?.is_manager_page_visible,
          //   is_user_page_visible:  menu?.is_user_page_visible,
          //   is_userdefined_page1_visible: menu?.is_userdefined_page1_visible,
          //   is_userdefined_page2_visible: menu?.is_userdefined_page2_visible,
          //   is_userdefined_page3_visible: menu?.is_userdefined_page3_visible,
          //   is_attendance_page_visible: menu?.is_attendance_page_visible
          // });

          // Call shop-user-mapping API
          if (this.userGroupInfo.id !== undefined && this.userGroupInfo.id !== null) {
            this.userService.getShopUserMapping(Number(this.userGroupInfo.id)).subscribe(res => {
              this.zone.run(() => {
                if (res.status === 'SUCCESS') {
                  this.shopUserMapping = [...res.data];
                  // Extract unique area/city list
                  this.areaList = Array.from(new Set(this.shopUserMapping.map(shop => shop.city))).filter(Boolean);
                  // By default, select all areas
                  this.selectedAreas = [...this.areaList];
                  this.sortedShopUserMapping = this.getFilteredAndSortedShopUserMapping();
                } else {
                  this.shopUserMapping = [];
                  this.areaList = [];
                  this.selectedAreas = [];
                  this.sortedShopUserMapping = [];
                }
                // this.shopUserMappingLoadedFromSetUserGroupInfo = true; // already set above
                console.log('shopUserMapping after setuserGroupInfo:', this.shopUserMapping);
                this.cdr.detectChanges();
              });
            });
          }

          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.userGroupInfo.id == 0) ? "New User Group" : "Editing : " + this.userGroupInfo.name;
    return title;
  }

  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {
    if (this.editForm.valid) {
      const form = this.editForm.value;
      this.editForm.markAllAsTouched();
      Object.assign(this.userGroupInfo, this.editForm.value);
      // Convert is_active boolean to number for the model
      this.userGroupInfo.is_active = this.editForm.value.is_active ? 1 : 0;
      this.userGroupInfo.user_type = this.getUserTypeValue();

      // Prepare full shops data for payload
      const shopsPayload = this.shopUserMapping.map(shop => ({
        ...shop,
        is_exists: (shop.is_exists == '1' || shop.is_exists === 1 || shop.is_exists === true) ? '1' : '0'
      }));
      this.userGroupInfo.shops = shopsPayload;

      // Encrypt password if present and not already encrypted
      if (this.userGroupInfo.password && !this.userGroupInfo.password.startsWith('U2Fsd')) {
        const secretKey = 'your-secret-key'; // Use a secure key and keep it in sync with your backend
        this.userGroupInfo.password = CryptoJS.AES.encrypt(this.userGroupInfo.password, secretKey).toString();
      }

      this.userService.update(this.userGroupInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.userGroupInfo.name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }


  loadUserGroupData(): void {

    let requestData = { "search": { "filters": { "simpleSearch": [], "advSearch": [], "scope": { "limit": 1000, "offset": 0 } }, "sort": [{ "column": "name", "order": "asc" }] } }
    let response = this.userGroupService.getList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.userGroupList = response.data.user_groups;


      }

    });

  }

  loadEmployeeData(): void {

    let requestData = { "search": { "filters": { "simpleSearch": [], "advSearch": [], "scope": { "limit": 1000, "offset": 0 } }, "sort": [{ "column": "f_name", "order": "asc" }] } }
    let response = this.employeeService.getEmployeeList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        //this.categoryList = response.data.categories;
        this.employeeList = response.data.employees;
      }
    });

  }

  openChangePasswordDialog(): void {
    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      width: '350px',
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.newPassword) {
        // Set the new password in the payload
        this.userGroupInfo.password = result.newPassword;
        this.editForm.patchValue({ password: result.newPassword });
        this.snackBarService.openSnackBar({
          type: 'success',
          title: 'Password Changed',
          message: 'Password updated successfully.'
        });
      }
    });
  }

  dateRangeValidator(form: FormGroup) {
    const from = form.get('valid_from')?.value;
    const to = form.get('valid_to')?.value;
    if (from && to) {
      const fromDate = new Date(from);
      const toDate = new Date(to);
      if (!isNaN(fromDate.getTime()) && !isNaN(toDate.getTime()) && fromDate > toDate) {
        form.get('valid_from')?.setErrors({ dateRange: true });
        form.get('valid_to')?.setErrors({ dateRange: true });
        return { dateRange: true };
      } else {
        if (form.get('valid_from')?.hasError('dateRange')) {
          form.get('valid_from')?.setErrors(null);
        }
        if (form.get('valid_to')?.hasError('dateRange')) {
          form.get('valid_to')?.setErrors(null);
        }
      }
    } else {
      if (form.get('valid_from')?.hasError('dateRange')) {
        form.get('valid_from')?.setErrors(null);
      }
      if (form.get('valid_to')?.hasError('dateRange')) {
        form.get('valid_to')?.setErrors(null);
      }
    }
    return null;
  }

  getSortedShopUserMapping(data: any[]): any[] {
    return [...data].sort((a, b) => {
      if (a.code < b.code) return 1;
      if (a.code > b.code) return -1;
      return b.name.localeCompare(a.name);
    });
  }

  trackByShop(index: number, shop: any) {
    return shop.id || shop.code;
  }

  // Add this helper method to the class:
  toBoolean(val: any): boolean {
    return val === true || val === 1 || val === '1';
  }

  isShopChecked(shop: any): boolean {
    return String(shop.is_exists) === '1';
  }

  onShopCheckboxChange(shop: any, checked: boolean) {
    // Find index and replace with new object (immutability)
    const idx = this.shopUserMapping.findIndex(s => (s.id || s.code) === (shop.id || shop.code));
    if (idx > -1) {
      this.shopUserMapping = [
        ...this.shopUserMapping.slice(0, idx),
        { ...shop, is_exists: checked ? '1' : '0' },
        ...this.shopUserMapping.slice(idx + 1)
      ];
      // Use the filtering method to preserve current filters
      this.sortedShopUserMapping = this.getFilteredAndSortedShopUserMapping();
      this.cdr.detectChanges();
    }
  }

  // Helper to get filtered and sorted shops based on selected areas
  getFilteredAndSortedShopUserMapping(): any[] {
    let filtered = this.shopUserMapping;
    if (this.selectedAreas && this.selectedAreas.length > 0) {
      filtered = filtered.filter(shop => this.selectedAreas.includes(shop.city));
    }
    if (this.shopSearch && this.shopSearch.trim() !== '') {
      const search = this.shopSearch.trim().toLowerCase();
      filtered = filtered.filter(shop =>
        (shop.code && shop.code.toLowerCase().includes(search)) ||
        (shop.name && shop.name.toLowerCase().includes(search)) ||
        (shop.city && shop.city.toLowerCase().includes(search))
      );
    }
    return this.getSortedShopUserMapping(filtered);
  }

  onShopSearchChange(search: string) {
    this.shopSearch = search;
    this.sortedShopUserMapping = this.getFilteredAndSortedShopUserMapping();
    this.cdr.detectChanges();
  }

  isAllShopsChecked(): boolean {
    return this.sortedShopUserMapping.length > 0 &&
      this.sortedShopUserMapping.every(shop => this.isShopChecked(shop));
  }

  isSomeShopsChecked(): boolean {
    return this.sortedShopUserMapping.some(shop => this.isShopChecked(shop)) &&
      !this.isAllShopsChecked();
  }

  onSelectAllShops(checked: boolean) {
    const updated = this.shopUserMapping.map(shop => {
      // Only update shops in the current filtered list
      if (this.sortedShopUserMapping.some(s => (s.id || s.code) === (shop.id || shop.code))) {
        return { ...shop, is_exists: checked ? '1' : '0' };
      }
      return shop;
    });
    this.shopUserMapping = updated;
    this.sortedShopUserMapping = this.getFilteredAndSortedShopUserMapping();
    this.cdr.detectChanges();
  }
  // Call this when area selection changes from the dropdown
  onAreaSelectionChange(selected: string[]) {
    this.selectedAreas = selected;
    this.sortedShopUserMapping = this.getFilteredAndSortedShopUserMapping();
    this.cdr.detectChanges();
  }
}

// Dialog component for password change
@Component({
  selector: 'app-change-password-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule
  ],
  template: `
      <h2 mat-dialog-title>Change Password</h2>
      <mat-dialog-content>
        <form [formGroup]="passwordForm">
          <mat-form-field style="width:100%">
            <mat-label>New Password</mat-label>
            <input matInput type="password" formControlName="newPassword">
            <mat-error *ngIf="passwordForm.controls['newPassword'].hasError('required')">Required</mat-error>
          </mat-form-field>
          <mat-form-field style="width:100%">
            <mat-label>Confirm Password</mat-label>
            <input matInput type="password" formControlName="confirmPassword">
            <mat-error *ngIf="passwordForm.controls['confirmPassword'].hasError('required')">Required</mat-error>
            <mat-error *ngIf="passwordForm.hasError('passwordMismatch')">Passwords do not match</mat-error>
          </mat-form-field>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()">Cancel</button>
        <button mat-button color="primary" (click)="onSave()" [disabled]="passwordForm.invalid">Save</button>
      </mat-dialog-actions>
    `
})
export class ChangePasswordDialogComponent {
  passwordForm: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.passwordForm = this.fb.group({
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });
  }
  passwordMatchValidator(form: FormGroup) {
    return form.get('newPassword')!.value === form.get('confirmPassword')!.value ? null : { passwordMismatch: true };
  }
  onCancel(): void {
    this.dialogRef.close();
  }
  onSave(): void {
    if (this.passwordForm.valid) {
      this.dialogRef.close({ newPassword: this.passwordForm.value.newPassword });
    }
  }
}